import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import classNames from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import { WEEK_DAY_ABBREVIATIONS } from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/constants';

interface Props {
  day: keyof typeof WEEK_DAY_ABBREVIATIONS;
  checked: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function WeekDayCheckBox({ day, checked, disabled = false, onChange }: Props) {
  const classes = useStyles();
  const weekDayAbbr = WEEK_DAY_ABBREVIATIONS[day];

  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      icon={
        <div className={classes.unselectedDay}>
          <Typography variant="body2" className={classes.weekDayAbbr}>
            {weekDayAbbr}
          </Typography>
        </div>
      }
      inputProps={{ 'aria-label': day }}
      checkedIcon={
        <div
          className={classNames(classes.selectedDay, { [classes.disabledSelectedDay]: disabled })}
        >
          <Typography variant="body2" className={classes.weekDayAbbr}>
            {weekDayAbbr}
          </Typography>
        </div>
      }
      disabled={disabled}
    />
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {},
  unselectedDay: {
    width: 38,
    height: 38,
    backgroundColor: theme.palette.text.hint,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectedDay: {
    width: 38,
    height: 38,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  weekDayAbbr: {
    fontWeight: 'bold',
  },
  disabledSelectedDay: {
    backgroundColor: theme.palette.text.disabled,
  },
}));

export default WeekDayCheckBox;
